import _default from './Select';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Select/index.js
// module id = 1122
// module chunks = 1